import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import CampaignsAPI from '../../api/campaigns';
import AnalyticsHelper from '../../helper/AnalyticsHelper';
import { CAMPAIGNS_EVENTS } from '../../helper/AnalyticsHelper/events';

export const state = {
  records: [],
  meta: {},
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isAnalyzingFile: false,
    isDeleting: false    
  },
  fileAnalysis: {
    countWithoutName: 0,
    countWithoutPhone: 0,
    countWithInvalidPhone: 0,
    countWithDuplicatePhone: 0,
    countValid: 0    
  }
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getCampaigns: _state => campaignType => {
    return _state.records.filter(
      record => record.campaign_type === campaignType
    );
  },
  getMeta(_state) {
    return _state.meta;
  },
  getAllCampaigns: _state => {
    return _state.records;
  },  
  getFileAnalysis(_state) {
    return _state.fileAnalysis;
  }
};

export const actions = {
  getCampaignWhatsapp: async function getCampaigns({ commit }, params) {
    commit(types.SET_CAMPAIGN_UI_FLAG, { isFetching: true });
    try {
      const { page, sortAttr, limit, combo_select } = params;
      const response = await CampaignsAPI.getWhatsapp(page, sortAttr, limit, combo_select);
      commit(types.SET_CAMPAIGNS, response.data.payload);
      commit(types.SET_META, response.data.meta);
    } catch (error) {      
      // Ignore error
    } finally {
      commit(types.SET_CAMPAIGN_UI_FLAG, { isFetching: false });
    }
  },
  get: async function getCampaigns({ commit }) {
    commit(types.SET_CAMPAIGN_UI_FLAG, { isFetching: true });
    try {
      const response = await CampaignsAPI.get();
      commit(types.SET_CAMPAIGNS, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_CAMPAIGN_UI_FLAG, { isFetching: false });
    }
  },
  create: async function createCampaign({ commit }, campaignObj) {
    commit(types.SET_CAMPAIGN_UI_FLAG, { isCreating: true });
    try {
      const response = await CampaignsAPI.create(campaignObj);
      commit(types.ADD_CAMPAIGN, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CAMPAIGN_UI_FLAG, { isCreating: false });
    }
  },
  createFormData: async function createFormDataCampaign({ commit }, campaignObj) {
    commit(types.SET_CAMPAIGN_UI_FLAG, { isCreating: true });
    try {
      const response = await CampaignsAPI.createFormData(campaignObj);
      commit(types.ADD_CAMPAIGN, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CAMPAIGN_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { id, ...updateObj }) => {
    commit(types.SET_CAMPAIGN_UI_FLAG, { isUpdating: true });
    try {
      const response = await CampaignsAPI.update(id, updateObj);
      AnalyticsHelper.track(CAMPAIGNS_EVENTS.UPDATE_CAMPAIGN);
      commit(types.EDIT_CAMPAIGN, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CAMPAIGN_UI_FLAG, { isUpdating: false });
    }
  },
  delete: async ({ commit }, id) => {
    commit(types.SET_CAMPAIGN_UI_FLAG, { isDeleting: true });
    try {
      await CampaignsAPI.delete(id);
      AnalyticsHelper.track(CAMPAIGNS_EVENTS.DELETE_CAMPAIGN);
      commit(types.DELETE_CAMPAIGN, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CAMPAIGN_UI_FLAG, { isDeleting: false });
    }
  },
  search: async ({ commit }, params) => {
    commit(types.SET_CAMPAIGN_UI_FLAG, { isFetching: true });
    try {
      const { page, sortAttr, search } = params;
      const response = await CampaignsAPI.search(page, sortAttr, search);

      commit(types.SET_CAMPAIGNS, response.data.payload);
      commit(types.SET_META, response.data.meta);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_CAMPAIGN_UI_FLAG, { isFetching: false });
    }
  },
  fileAnalysis: async ({ commit }, { file, countryDDI }) => {
    commit(types.SET_CAMPAIGN_UI_FLAG, { isAnalyzingFile: true });    
    try {      
      const response = await CampaignsAPI.analyzeFile(file, countryDDI);
    } catch (error) {
      commit(types.SET_CAMPAIGN_FILE_ANALYSIS, null);    
      commit(types.SET_CAMPAIGN_UI_FLAG, { isAnalyzingFile: false });
      throw error;
    }
  },
  updateUiFlag: ({ commit }, { flag, value }) => {
    commit(types.SET_CAMPAIGN_UI_FLAG, { [flag]: value });
  },
  setCampaignFileAnalysis: ({ commit, state }, data) => {
    if (state.uiFlags.isAnalyzingFile) {
      commit(types.SET_CAMPAIGN_FILE_ANALYSIS, data);
      commit(types.SET_CAMPAIGN_UI_FLAG, { isAnalyzingFile: false });
    }
  },
  editValueCampaign: ({ commit }, data) => {
    console.log(data);
    commit(types.EDIT_CAMPAIGN, data);
  }
};

export const mutations = {
  [types.SET_CAMPAIGN_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.SET_META](_state, data) {
    _state.meta = data;
  },

  [types.ADD_CAMPAIGN]: MutationHelpers.create,
  [types.SET_CAMPAIGNS]: MutationHelpers.set,
  [types.EDIT_CAMPAIGN]: MutationHelpers.update,
  [types.DELETE_CAMPAIGN]: MutationHelpers.destroy,
  [types.SET_CAMPAIGN_FILE_ANALYSIS](_state, data) {    
    _state.fileAnalysis = data;
  },
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
